import { slugToTitle } from "@/lib/slug";

/**
 * SEO-safe fallback shell for the venue details route.
 * Used when the loader returns null (transient backend failure)
 * and by VenueDetailsErrorBoundary.
 */
export function VenueDetailsFallback({ slug }: { slug: string }) {
  const title = slugToTitle(slug);
  return (
    <main id="main" className="max-w-[1440px] mx-auto p-8 bg-bg-brand-secondary-default">
      <h1 className="title-m-bold mb-4">{title}</h1>
      <p className="body-m-regular text-fg-neutral-subtle">
        Accessibility information for {title}. Loading venue details...
      </p>
    </main>
  );
}
